/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/

import { ColorThemeConfig } from './types';

export const LS_GOOGLE_DOC_IDS_KEY = 'LS_GOOGLE_DOC_IDS_KEY';

export const URL_PARAM_NEW_DOC = 'newDoc';

export const BLUE_HEX = '#1B6A9C';
export const DARK_BLUE_HEX = '#42A5F5';
export const LIGHT_BLUE_HEX = '#a6e3ff';

export const DEFAULT_COLOR_THEME: ColorThemeConfig = {
  headerColor: BLUE_HEX,
  headerButtonsColor: LIGHT_BLUE_HEX,
  chatSystemBubbleColor: DARK_BLUE_HEX,
  chatSystemTextColor: 'white',
  chatUserBubbleColor: LIGHT_BLUE_HEX,
  chatUserTextColor: 'black',
};

export const LOADING_NAME = 'Loading';

export const MOBILE_CUTOFF_SIZE = 1300;

export const FREE_INPUT_GOAL_ID = '65823a8799045156193339b2';

export const STRONGER_HOOK_ID = '658230f699045156193339ac';
export const STRONGER_CONCLUSION_ID = '66144d071e930b07906a7833';
export const LIMITS_TO_YOUR_ARGUMENT_ID = '6619c3fe9965e7b71fd2f215';
export const THESIS_SUPPORT_ID = '6616fe864eba4870d62f3f3c';
